export default {"src":"/_next/static/media/CNPJ.0c380edd.svg","height":340,"width":513,"blurWidth":0,"blurHeight":0};